// Libraries
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function parseTextItem(item) {
  const taggedID = item.substring(9, item.length);
  switch (item.substring(0, 9)) {
    case "[CATLINK]":
      return <Link to={"/gallery/?category=" + taggedID}>{taggedID}</Link>;
    case "[TAGLINK]":
      return <Link to={"/gallery/?tags=" + taggedID}>{taggedID}</Link>;
    default:
      return item;
  }
}

const OrderedList = ({ items, type }) => {
  return (
    <ul className="list-group list-group-flush">
      {type === "text"
        ? items.map((item) => (
            <li
              key={item}
              className="list-group-item"
              style={{ background: "#fff0" }}
            >
              {parseTextItem(item)}
            </li>
          ))
        : items.map((item) => (
            <li
              key={item._id ? item._id : item.name}
              className="list-group-item"
              style={{ background: "#fff0" }}
            >
              {/* <strong>{items.indexOf(item) + 1}.</strong>  */}
              {item.name}
            </li>
          ))}
    </ul>
  );
};

// Typechecking
OrderedList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default OrderedList;
